import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { RelatedSearchPlaceholder } from './RelatedSearch/RelatedSearchPlaceholder';
import { dataModelRelatedSearch, defaultPropsRelatedSearch, propTypesRelatedSearch } from './RelatedSearch/constants';

const placeholder = (
  <RelatedSearchPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('./RelatedSearch/RelatedSearchComponent')).RelatedSearchComponent;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "related-search-component" */
      './RelatedSearch/RelatedSearchComponent');
  },
  placeholder,
  name: 'RelatedSearchComponent',
});

const HydratedRelatedSearch = withHydrator({
  id: 'related-search',
  scrollBuffer: 750,
  delay: 2000,
  preserveCtxVal: 'clientStore',
  placeholder,
}, ImportedComponent);

const DynamicRelatedSearch = withDynamicComponent(HydratedRelatedSearch);
const RelatedSearchImporter = withErrorBoundary(DynamicRelatedSearch);

RelatedSearchImporter.displayName = 'RelatedSearchImporter';
RelatedSearchImporter.dataModel = dataModelRelatedSearch;
RelatedSearchImporter.propTypes = propTypesRelatedSearch;
RelatedSearchImporter.defaultProps = defaultPropsRelatedSearch;

export { RelatedSearchImporter };